.portfolioPage {
  min-height: 100%;
  background: var(--ib-blush);
  padding: 22px 24px 64px 24px;
}

.pageHead {
  margin: 0 0 6px 0;
}

.pageTitle {
  margin: 0;
  font-family: var(--font-serif);
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ib-ink);
}

.portfolioTabs {
  padding: 0;
}

/* Keep the antd tab bar reading clean on blush (ink bar / active red come from the theme) */
.portfolioTabs :global(.ant-tabs-nav) {
  margin-bottom: 8px;
}

.portfolioTabs :global(.ant-tabs-nav::before) {
  border-bottom-color: var(--ib-line);
}

.portfolioTabs :global(.ant-tabs-tab) {
  font-weight: 600;
  color: var(--ib-muted);
}

.portfolioTabs :global(.ant-tabs-tab:hover) {
  color: var(--ib-ink);
}

.portfolioTabs :global(.ant-tabs-tab-active .ant-tabs-tab-btn) {
  color: var(--ib-red);
}

.portfolioCards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.orders {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  padding-top: 4px;
}

.order {
  min-width: 0;
}

@media only screen and (max-width: 900px) {
  .orders {
    grid-template-columns: 1fr;
  }
}

@media only screen and (max-width: 550px) {
  .portfolioPage {
    padding: 16px 14px 48px 14px;
  }
}
